import { ButtonApiErrorWrapper } from 'app/components/shared/ButtonApiErrorWrapper'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { useGetRegistryFileUser } from 'app/queries/user'
import { downloadFile } from 'app/utils/fileUtils'
import React from 'react'
import styled from 'styled-components'

export const InputRegistryDocumentDownload = (): JSX.Element => {
  const {
    error,
    isError,
    isLoading,
    refetch: getRegistryFile,
  } = useGetRegistryFileUser({
    executeOnStart: false,
    onSuccess: (data) => {
      downloadFile(data, 'anagrafica_sponsor_estra.pdf')
    },
  })

  return (
    <DownloadRegistryContainer>
      <ButtonApiErrorWrapper isError={isError} error={error} alignCenter>
        <Button
          size='lg'
          onClick={() => {
            getRegistryFile()
          }}
          disabled={isLoading}
        >
          {isLoading ? 'Caricamento...' : `SCARICA L'ANAGRAFICA E FIRMALA`}
        </Button>
      </ButtonApiErrorWrapper>
    </DownloadRegistryContainer>
  )
}

const DownloadRegistryContainer = styled(Container)`
  text-align: center;
`
